import request from '../utils/request'

export const AnnouncementService = {

    // Get all announcements with pagination and filtering
    getAllAnnouncements: async (params = {}) => {
        try {
            const response = await request.get('/announcements', { params })
            return response.data
        } catch (error) {
            console.log('Error fetching announcements:', error)
            throw error
        }
    },

    // Get announcement by ID
    getAnnouncementById: async (announcementId) => {
        try {
            const response = await request.get(`/announcements/${announcementId}`)
            const announcement = response.data?.announcement;

            // Convert ISO dates to datetime-local format for form inputs
            if (announcement) {
                return {
                    ...announcement,
                    startDate: announcement.startDate ? new Date(announcement.startDate).toISOString().slice(0, 16) : '',
                    endDate: announcement.endDate ? new Date(announcement.endDate).toISOString().slice(0, 16) : ''
                };
            }

            return announcement;
        } catch (error) {
            console.log('Error fetching announcement:', error)
            throw error
        }
    },

    // Create new announcement
    createAnnouncement: async (announcementData) => {
        try {
            // Clean up the data before sending
            const cleanData = { ...announcementData };

            // Convert empty strings to undefined for optional fields
            if (cleanData.startDate === '') cleanData.startDate = undefined;
            if (cleanData.endDate === '') cleanData.endDate = undefined;
            if (cleanData.imageUrl === '') cleanData.imageUrl = undefined;
            if (cleanData.actionUrl === '') cleanData.actionUrl = undefined;
            if (cleanData.actionText === '') cleanData.actionText = undefined;

            // Convert datetime-local format to ISO string if dates exist
            if (cleanData.startDate) {
                cleanData.startDate = new Date(cleanData.startDate).toISOString();
            }
            if (cleanData.endDate) {
                cleanData.endDate = new Date(cleanData.endDate).toISOString();
            }

            console.log('Sending announcement data:', cleanData);
            const response = await request.post('/announcements', cleanData)
            return response.data?.announcement
        } catch (error) {
            console.log('Error creating announcement:', error.response?.data || error)
            throw error
        }
    },

    // Update announcement
    updateAnnouncement: async (announcementId, updateData) => {
        try {
            // Clean up the data before sending
            const cleanData = { ...updateData };

            // Convert empty strings to undefined for optional fields
            if (cleanData.startDate === '') cleanData.startDate = undefined;
            if (cleanData.endDate === '') cleanData.endDate = undefined;
            if (cleanData.imageUrl === '') cleanData.imageUrl = undefined;
            if (cleanData.actionUrl === '') cleanData.actionUrl = undefined;
            if (cleanData.actionText === '') cleanData.actionText = undefined;

            // Convert datetime-local format to ISO string if dates exist
            if (cleanData.startDate) {
                cleanData.startDate = new Date(cleanData.startDate).toISOString();
            }
            if (cleanData.endDate) {
                cleanData.endDate = new Date(cleanData.endDate).toISOString();
            }

            console.log('Sending update data:', cleanData);
            const response = await request.patch(`/announcements/${announcementId}`, cleanData)
            return response.data?.announcement
        } catch (error) {
            console.log('Error updating announcement:', error.response?.data || error)
            throw error
        }
    },

    // Delete announcement
    deleteAnnouncement: async (announcementId) => {
        try {
            const response = await request.delete(`/announcements/${announcementId}`)
            return response.data
        } catch (error) {
            console.log('Error deleting announcement:', error)
            throw error
        }
    },

    // Toggle announcement active status
    toggleAnnouncementStatus: async (announcementId) => {
        try {
            const response = await request.patch(`/announcements/${announcementId}/toggle`)
            return response.data
        } catch (error) {
            console.log('Error toggling announcement status:', error)
            throw error
        }
    },

    // Get announcement statistics
    getAnnouncementStats: async () => {
        try {
            const response = await request.get('/announcements/stats')
            return response.data
        } catch (error) {
            console.log('Error fetching announcement stats:', error)
            throw error
        }
    }
}
